import type { ApiClient } from '@travel/api-client';

import { MONTEROSA_API_TIMEOUT } from 'store/utils';

import type {
  HotelListMap,
  HotelListMapRequestBody,
  HotelMapDetailsRequestBody,
} from 'HotelListMap-Types';
import type { HotelItem } from 'HotelList-Types';
export const fetchProviderLocationList = (
  http: ApiClient,
  query: HotelListMapRequestBody,
): Promise<HotelListMap> =>
  http.post('/monterosa-api-dp/dp/jrdp/provider-map-summaries', {
    values: query,
    timeout: MONTEROSA_API_TIMEOUT,
  });

export const fetchProviderDetails = (
  http: ApiClient,
  query: HotelMapDetailsRequestBody,
): Promise<HotelItem> =>
  http.post('/monterosa-api-dp/dp/jrdp/provider-map-details', {
    ignoreCommonErrorHandler: true,
    values: query,
    timeout: MONTEROSA_API_TIMEOUT,
  });
